import { BoardValue } from '../../../jscaip/AI/BoardValue';
import { PlayerMetricHeuristicWithBounds } from '../../../jscaip/AI/Minimax';
export class MancalaScoreHeuristic extends PlayerMetricHeuristicWithBounds {
    getMetrics(node, _config) {
        return node.gameState.getScoresCopy().toTable();
    }
    getBounds(config) {
        // At most, we can get all seeds, which is:
        // - the number of seeds per house (seedsByHouse)
        // - for each house (width)
        // - for each player (2 players)
        const maxScore = config.width * 2 * config.seedsByHouse;
        return {
            player0Best: BoardValue.ofSingle(maxScore, 0),
            player1Best: BoardValue.ofSingle(0, maxScore),
        };
    }
}
